export const DEFAULT_DAMAGE_WAIVER_CONFIG = Object.freeze({
  enabled: false,
  feeAmount: null,
  displayLabel: 'Damage Waiver',
  description: '',
});

export const getDamageWaiverFeeAmount = config =>
  config?.enabled === true && Number.isSafeInteger(config?.feeAmount) && config.feeAmount > 0
    ? config.feeAmount
    : 0;
